module.exports = __webpack_public_path__ + "static/img/年度最佳Ai笔记本.f3dd98e8.png";